import { faCalendarAlt, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { forwardRef, useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Button, Col, Collapse, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { es as dateLocaleEs } from 'date-fns/locale/es';
import Select from "react-select";
import { jwtDecode } from 'jwt-decode';
import {
  AlertaService,
  GruposService,
  VehiculosService,
  GeocercaService,
  ClienteService,
  ReferenciaService,
} from "../../../../services/apiService";

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { sortBy } from "underscore";

import { MultiSelect } from 'primereact/multiselect';
import "primereact/resources/themes/lara-light-blue/theme.css";

import { locale as primeLocale, addLocale } from 'primereact/api'
import { useFiltrosStore } from "../../../../lib/store/filtros.store";
import { Dropdown } from "primereact/dropdown";
import '../../../../styles/global.css'
import { createRenderCustomHeader } from '../../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../../utils/datePickerUtils';
import '../../../../styles/datepicker.css'
import { AccionBitacora, generarObservacion, guardarBitacora } from "../../../../utils/bitacora";
import { paginadorAlertasStore, paginadoRecorridosStore } from "../../../../lib/store/paginador_store";
import { set } from "date-fns";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale('es');

registerLocale('es', dateLocaleEs);
setDefaultLocale('es'); //

addLocale('es', {
  firstDayOfWeek: 1,
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
  monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  today: 'Hoy',
  clear: 'Limpiar',
  option: '',
  selectionMessage: '{0} items seleccionados',
  emptySearchMessage: 'No se encontraron resultados',
  emptyFilterMessage: 'No se encontraron resultados',
  emptyMessage: 'No hay opciones disponibles'
})

primeLocale('es')

//console.log(primeLocaleEs)

// Opciones para el select Tipo Vista
const tiposVista = [
  {
    value: 3,
    label: "Todos",
  },
  {
    value: 0,
    label: "Por geocerca",
  },
  {
    value: 1,
    label: "Por clientes",
  },
  {
    value: 2,
    label: "Por referencias",
  },
  {
    value: -1,
    label: "Indeterminado",
  },
];

// Opciones para el select Tipo Reporte
const tiposReportes = [
  {
    value: 0,
    label: "Por detenidos",
  },
  {
    value: 1,
    label: "Por apagados y encendidos de motor",
  },
  {
    value: 2,
    label: "Completo (Detenido y A/E)",
  },
  {
    value: 3,
    label: "Entrada y Salida",
  },
];

export default function Filtros({ onGenerateReport, imprimir, disabled }) {
  // Estados que guardan los datos obtenidos de los endpoint
  const [grupos, setGrupos] = useState([]);
  const paginadorRecorridos = paginadoRecorridosStore();
  //const [vehiculos, setVehiculos] = useState([]);
  //const [vehiculosFiltrados, setVehiculosFiltrados] = useState([]);

  // Estados que guardan el dato seleccionado en el formulario de filtros
  const [selectedGrupo, setSelectedGrupo] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [selectedTipoVista, setSelectedTipoVista] = useState(tiposVista[0].value);
  // const [selectedTipoReporte, setSelectedTipoReporte] = useState(tiposReportes[1]);
  const [selectedTipoReporte, setSelectedTipoReporte] = useState(tiposReportes[1].value);
  const [tiempoEstancia, setTiempoEstancia] = useState(0);
  const [btnFiltroActivo, setBtnFiltroActivo] = useState(false);
  const [cargandoTipoAlertas, editarCargandoTipoAlertas] = useState(false);
  const [tipoAlertas, editarTipoAlertas] = useState([]);

  const vehiculos = useFiltrosStore((state) => state.vehiculos)
  const setVehiculos = useFiltrosStore((state) => state.setVehiculos)
  const vehiculosFiltrado = useFiltrosStore((state) => state.vehiculosFiltrado)
  const setVehiculosFiltrados = useFiltrosStore((state) => state.setVehiculosFiltrados)
  const [geocercas, setGeocercas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [referencias, setReferencias] = useState([]);
  // Estado para abrir u ocultar el filtro
  const [open, setOpen] = useState(true);

  // Establecer valores iniciales para las fechas
  const now = new Date();
  const startOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0
  ); // Inicio del día (00:00:00)

  const endOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59
  ); // Fin del día (23:59:59)
  // Inicializar fechas con el día actual
  const [startDate, setStartDate] = useState(startOfDay);
  const [endDate, setEndDate] = useState(endOfDay);
  const [dateRangeWarning, setDateRangeWarning] = useState("");
  const [dateRangeInvalid, setDateRangeInvalid] = useState(false);

  // Handle functions for DatePicker onChange and custom header
  const handleStartDateChangeWrapper = useCallback((date) => {
    handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
  }, [startDate, endDate]);

  const handleEndDateChangeWrapper = useCallback((date) => {
    handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
  }, [startDate, endDate]);

  // Validar rango de fechas: máximo 1 día
  useEffect(() => {
    if (!startDate || !endDate) return;
    const diffMs = endDate - startDate;
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    if (diffDays > 30) {
      setDateRangeWarning("El rango máximo permitido es de 15 días.");
      setDateRangeInvalid(true);
      // import('sweetalert2').then(Swal => {
      //   Swal.default.fire({
      //     icon: 'warning',
      //     title: 'Rango de fechas inválido',
      //     text: 'El rango máximo permitido es de 1 día.',
      //   });
      // });
    } else {
      setDateRangeWarning("");
      setDateRangeInvalid(false);
    }
  }, [startDate, endDate]);

  const loadGrupos = async () => {
    try {
      const response = await GruposService.getGrupos();
      if (response && response.statusCode === 200) {

        const _grupos = sortBy(response.data, 'nombre')

        const gruposData = _grupos.map((grupo) => ({
          value: grupo.uid_grupo,
          label: `${grupo.nombre}`,
          uid_grupo: grupo.uid_grupo
        }));

        //setSelectedGrupo(gruposData)
        setGrupos(gruposData);
      }
    } catch (error) {
      console.error("Error cargando los grupos:", error);
    }
  };

  const loadVehiculos = async () => {
    try {
      const response = await VehiculosService.getVehiculos();

      if (response && response.statusCode === 200) {
        const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

        const vehiculosData = _vehiculos.map(vehiculo => ({
          value: vehiculo.uid_vehiculo ?? "",
          label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
          uid_grupo: vehiculo.uid_grupo ?? "",
          no_economico: vehiculo.no_economico ?? "",
          alias: `${vehiculo.alias ?? ""}`,
          tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
          color_vehiculo: (vehiculo?.color_vehiculo || 'black').toLocaleLowerCase().replace('white', '#e8e8e8').replace('#ffffff', '#e8e8e8')
        }));
        setVehiculos(vehiculosData);
        setVehiculosFiltrados([]);
      }
    } catch (error) {
      console.error("Error cargando vehículos:", error);
    }
  };


  // 🚗 Cargar Vehículos
  // const loadVehiculos = async () => {
  //   try {
  //     const response = await VehiculosService.getVehiculos();
  //     if (response && response.statusCode === 200) {

  //       const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })

  //       const vehiculosData = _vehiculos.map((vehiculo) => ({
  //         value: vehiculo.uid_vehiculo,
  //         label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
  //         uid_grupo: vehiculo.uid_grupo,
  //         no_economico: vehiculo.no_economico,
  //         alias: `${vehiculo.alias}`
  //       }));
  //       setVehiculos(vehiculosData);
  //       setVehiculosFiltrados([])

  //     }
  //   } catch (error) {
  //     console.error("Error cargando vehículos:", error);
  //   }
  // };

  const loadGeocercas = async () => {
    try {
      const response = await GeocercaService.getGeocercas();
      if (response && response.statusCode === 200) {
        console.log(response);
        const _geocercas = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        setGeocercas(_geocercas);
      }
    } catch (err) {
      console.error("Error cargando geocercas:", err);
    }
  };

  const loadClientes = async () => {
    try {
      const response = await ClienteService.getClientes();
      if (response && response.statusCode === 200) {

        const _clientes = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        const clientesData = _clientes.map((cliente) => ({
          value: cliente.uid_cliente,
          label: `${cliente.nombre}`,
          nombre: `${cliente.nombre}`,
          latitud: cliente.latitud,
          longitud: cliente.longitud,
          radio: cliente.radio || 0, // Asegurarse de que radio tenga un valor por defecto
        }))
        setClientes(clientesData);
      }
    } catch (err) {
      console.error("Error cargando clientes:", err);
    }
  };

  const loadReferencias = async () => {
    try {
      const response = await ReferenciaService.getReferencias();
      if (response && response.statusCode === 200) {

        const _referencias = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        const referenciasData = _referencias.map((referencia) => ({
          value: referencia.uid_referencia,
          label: `${referencia.nombre}`,
          nombre: `${referencia.nombre}`,
          latitud: referencia.latitud,
          longitud: referencia.longitud,
          radio: referencia.radio || 0, // Asegurarse de que radio tenga un valor por defecto
        }))
        setReferencias(referenciasData);

      }
    } catch (err) {
      console.log("Error cargando referencias:", err);
    }
  };

  // const handleChangeTipoReporte = (tipoReporte) => {

  //   setSelectedTipoVista(tipoReporte != 3 ? tiposVista[0].value : tiposVista[1].value);
  //   setSelectedTipoReporte(tipoReporte);
  // }

  const handleChangeTipoReporte = (tipoReporte) => {
    // ✅ Configurar tipo de vista según el tipo de reporte
    setSelectedTipoVista(tipoReporte != 3 ? tiposVista[0].value : tiposVista[1].value);

    // ✅ Configurar tiempo de estancia según el tipo de reporte
    if (tipoReporte === 0) {
      // "Por detenidos" - establecer 3 minutos por defecto
      setTiempoEstancia(3);
    } else {
      // Cualquier otro tipo de reporte - establecer 0 minutos
      setTiempoEstancia(0);
    }

    setSelectedTipoReporte(tipoReporte);
  }


  const handleFieldChange = (e) => {
    const { value } = e.target;
    setTiempoEstancia(value);
  };

  // Al seleccionar los filtros, los pasamos al contenedor padre (index)
  const handleGenerate = () => {
    setOpen(false);

    // 🔹 Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
    /*const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
    const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
    const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC*/

    const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
    const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")
    generarBitacoraReporte(AccionBitacora.Generar);

    const vehiculosSeleccionados = Array.isArray(selectedVehicle) ? selectedVehicle : [];
    const uidsVehiculos = vehiculosSeleccionados
      .map((entry) => (typeof entry === "string" ? entry : entry?.value))
      .filter(Boolean);

    const vehiculosDetalle = vehiculosSeleccionados
      .map((entry) => {
        if (!entry) {
          return null;
        }

        if (typeof entry === "string") {
          return vehiculos.find((vehiculo) => vehiculo.value === entry) || null;
        }

        if (entry.value && entry.label) {
          return entry;
        }

        return vehiculos.find((vehiculo) => vehiculo.value === entry.value) || null;
      })
      .filter(Boolean)
      .map((vehiculo) => ({
        uid_vehiculo: vehiculo.value ?? vehiculo.uid_vehiculo ?? "",
        no_economico: vehiculo.no_economico ?? "",
        alias: vehiculo.alias ?? "",
        label: vehiculo.label ?? "",
        color_vehiculo: vehiculo.color_vehiculo,
        tipo_vehiculo: vehiculo.tipo_vehiculo,
      }));

    const decoded = jwtDecode(localStorage.getItem('token'));
    onGenerateReport({
      fecha_inicio: _fechaInicio,
      fecha_fin: _fechaFin,
      uids_vehiculos: uidsVehiculos,
      vehiculos_detalle: vehiculosDetalle,
      geocercas: geocercas,
      clientes: clientes,
      referencias: referencias,
      ids_tipo_alerta: tipoAlertas,
      tipo_vista: selectedTipoVista ? selectedTipoVista : 0,
      tipo_reporte: selectedTipoReporte ? selectedTipoReporte : 0,
      tiempo_estancia: tiempoEstancia ? tiempoEstancia : 0,
      distancia_estancia: 0,//estaticos
      encendido_o_apagado: "Todo", //estaticos
      empresaUid: decoded.uid_empresa,
      uid_usuario: decoded.uid_usuario,
      perfil: 1,
      count: true,
      order: 1
    });
  };

  useEffect(() => {
    guardarBitacora({ categoria: 'Reporte Estadías', observacion: 'Estadías', tipoAccion: AccionBitacora.EntrarReporte });
    window.guardarBitacoraPrint = () => {
      generarBitacoraReporte(AccionBitacora.Imprimir);
    };
    window.guardarBitacoraExport = () => {
      generarBitacoraReporte(AccionBitacora.Exportar);
    };
  }, []);
  const filtrosGenerarRef = useRef();
  const generarBitacoraReporte = (accion) => {
    if (accion === AccionBitacora.Generar) {
      let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
      let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
      let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
      let dataGrupos = (grupos || []).filter(w => (selectedGrupo || []).includes(w.value));
      let dataVehiculos = (vehiculos || []).filter(w => (selectedVehicle || []).includes(w.value));
      let dataAlertas = [];
      filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
    }
    guardarBitacora({
      categoria: 'Reporte Estadías',
      observacion: generarObservacion(
        'Estadías',
        {
          fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
          hora_inicio: filtrosGenerarRef.current.hora_inicio,
          fecha_fin: filtrosGenerarRef.current.fecha_fin,
          grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
          vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
          tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
        }
      ),
      tipoAccion: accion
    });
  }
  useEffect(() => {
    loadGrupos();
    loadVehiculos();
    cargarTipoAlertas();
    loadGeocercas();
    loadClientes();
    loadReferencias();
  }, []);


  // 👥 Cargar tipo alertas
  const cargarTipoAlertas = async () => {
    if (cargandoTipoAlertas)
      return;
    editarCargandoTipoAlertas(true);
    try {
      const response = await AlertaService.getTipoAlertaQuro();
      if (response && response.statusCode === 200) {
        const alertasIdList = (response.data.sort((a, b) => a.orden - b.orden)).map(item => { return item.tipo_alerta });
        editarTipoAlertas(alertasIdList);
      }
    } catch (error) {
      console.error("Error cargando los tipo de alertas:", error);
    } finally {
      editarCargandoTipoAlertas(false);
    }
  };

  useEffect(() => {
    /*if (selectedGrupo && selectedGrupo.value) {
      // Filtrar los vehículos que pertenecen al grupo seleccionado
      const filtrados = selectedGrupo.value.length > 0 ? vehiculos.filter(
        (vehiculo) => vehiculo.uid_grupo === selectedGrupo.value
      ) : vehiculos;
      setVehiculosFiltrados(filtrados);
    } else {
      // Si no se selecciona grupo, mostrar todos los vehículos
      setVehiculosFiltrados(vehiculos);
    }*/
    setVehiculosFiltrados(selectedGrupo || [])
    //console.log(selectedGrupo)
  }, [selectedGrupo]);

  useEffect(() => {
    if (selectedVehicle.length > 0) {
      setBtnFiltroActivo(true)
    } else {
      setBtnFiltroActivo(false)
    }
  }, [selectedVehicle])

  // 📌 Personalizar la vista del Select
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "34px",
      overflow: "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "34px",
      overflow: "hidden",
      paddingLeft: '0px'
    }),
  };

  // 📌 Método para manejar la selección de vehículos filtrados o agrupados
  /*const handleSelectChange = (selected, options, setSelected) => {
    const allSelected = selected.some((option) => option.value === "all");
 
    if (allSelected) {
      if (selected.length === vehiculosFiltrados.length + 1) {
        setSelected([]); // 🔹 Deseleccionar todo
      } else {
        setSelected(vehiculosFiltrados); // 🔹 Seleccionar solo los filtrados
      }
    } else {
      setSelected(selected);
    }
  };*/

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="position-relative">
      <Form.Control
        ref={ref}
        onClick={onClick}
        value={value}
        onChange={() => { }}
      />
    </div>
  ));

  const renderIniHeader = useMemo(
    () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
    [startDate, handleStartDateChangeWrapper]
  );
  const renderEndHeader = useMemo(
    () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
    [endDate, handleEndDateChangeWrapper]
  );

  return (
    <div>
      {/* <Button
        onClick={() => setOpen(!open)}
        aria-controls="filter-collapse"
        aria-expanded={open}
        variant="link"
        className="mt-2 mb-2"
      >
        <FontAwesomeIcon icon={faFilter} />
        {open ? " Ocultar filtros" : " Ver filtros"}
      </Button> */}
      {/* <Collapse in={open}> */}
      <div id="filter-collapse">

        {dateRangeWarning && (
          <Col xs={12}>
            <div className="alert alert-warning py-2 my-2">
              {dateRangeWarning}
            </div>
          </Col>
        )}


        <Row className="mb-3" >
          {/* Fecha Incicio */}
          <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Desde</Form.Label>
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChangeWrapper}
                customInput={<ExampleCustomInput />}
                timeIntervals={5}
                dateFormat="dd/MM/yyyy HH:mm:ss"
                /* showTimeSelect */
                renderCustomHeader={renderIniHeader}
                popperClassName="custom-datepicker-popper"
                fixedHeight
                locale="es"
                timeCaption="Hora"
                maxDate={new Date()}
                minTime={new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)}
                maxTime={
                  (startDate.getDate() === now.getDate() && startDate.getMonth() === now.getMonth() && startDate.getFullYear() === now.getFullYear())
                    ? now
                    : new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59)
                }
              />
            </Form.Group>
          </Col>
          {/* Fecha Fin */}
          <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Hasta</Form.Label>
              <DatePicker
                selected={endDate}
                minDate={startDate}
                minTime={
                  endDate.getDate() === startDate.getDate() && endDate.getMonth() === startDate.getMonth() && endDate.getFullYear() === startDate.getFullYear()
                    ? startDate
                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                }
                maxTime={
                  endDate.getDate() === now.getDate() && endDate.getMonth() === now.getMonth() && endDate.getFullYear() === now.getFullYear()
                    ? now
                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59)
                }
                onChange={handleEndDateChangeWrapper}
                customInput={<ExampleCustomInput />}
                timeIntervals={5}
                dateFormat="dd/MM/yyyy HH:mm:ss"
                /* showTimeSelect */
                renderCustomHeader={renderEndHeader}
                popperClassName="custom-datepicker-popper"
                fixedHeight
                locale="es"
                timeCaption="Hora"
                maxDate={now}
              />
            </Form.Group>
          </Col>
          {/* Grupos */}
          {/**
           * <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Grupo</Form.Label>
              <Select
                closeMenuOnSelect={true}
                options={[...grupos]}
                classNamePrefix="react-select"
                value={selectedGrupo}
                onChange={(selected) => setSelectedGrupo(selected)}
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}
          <Col md={3} xs={4} className="d-flex flex-column">
            <Form.Label>Grupo</Form.Label>
            <MultiSelect
              className="multiselect-ul w-full md:w-20rem"
              value={selectedGrupo}
              onChange={(e) => {
                setSelectedGrupo(e.value);
                setSelectedVehicle([]);
              }}
              options={grupos}
              optionLabel="label"
              filter
              placeholder="Seleccione un grupo"
              maxSelectedLabels={2}
              selectedItemsLabel={`${(selectedGrupo || []).length} grupos seleccionados`}
            />
          </Col>
          <Col md={3} xs={4} className="d-flex flex-column">
            <Form.Label>Vehículos</Form.Label>
            <MultiSelect
              className="multiselect-ul w-full md:w-20rem"
              value={selectedVehicle}
              onChange={(e) => {
                setSelectedVehicle(e.value)
              }}
              options={vehiculosFiltrado}
              optionLabel="label"
              filter
              placeholder="Seleccione un vehículo"
              maxSelectedLabels={2}
              selectedItemsLabel={`${(selectedVehicle || []).length} vehículos seleccionados`}
            />
          </Col>
        </Row>
        <Row className="mt-2">
          {/* Vehiculos */}
          {/**
           * <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Vehículos</Form.Label>
              <Select
                placeholder='Sin selección'
                closeMenuOnSelect={false}
                options={[
                  ...(selectedVehicle.length !== vehiculosFiltrados.length
                    ? [{ value: "all", label: "Seleccionar todos" }]
                    : [{ value: "all", label: "Deseleccionar todos" }]),
                  ...vehiculosFiltrados,
                ]}
                classNamePrefix="react-select"
                value={selectedVehicle}
                onChange={(selected) => handleSelectChange(selected, selectedVehicle, setSelectedVehicle)}
                isMulti
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}

          {/* Tipo de reporte */}
          <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Filtrar por evento</Form.Label>

              <Dropdown
                value={selectedTipoReporte}
                options={[...tiposReportes]}
                onChange={(selected) => handleChangeTipoReporte(selected.value)}
                optionLabel="label"
                placeholder="Selecciona un Evento..."
                className="w-full md:w-14rem"
                checkmark={true}
                highlightOnSelect={false}
                filter
              >
              </Dropdown>

              {/* <Select
                closeMenuOnSelect={true}
                options={[...tiposReportes]}
                classNamePrefix="react-select"
                value={selectedTipoReporte}
                onChange={(selected) => handleChangeTipoReporte(selected)}
                styles={customStyles}
              /> */}
            </Form.Group>
          </Col>

          {/* Tipo de vista */}
          <Col md={3} xs={4} className="">
            <Form.Group>
              <Form.Label>Filtrar por ubicación</Form.Label>

              <Dropdown
                value={selectedTipoVista}
                options={selectedTipoReporte == 3 ? [...tiposVista.filter(entry => [0, 1, 2].includes(entry.value))] : [...tiposVista]}
                onChange={(selected) => setSelectedTipoVista(selected.value)}
                optionLabel="label"
                placeholder="Sin Selección"
                className="w-full md:w-14rem"
                checkmark={true}
                highlightOnSelect={false}
                filter
              >

              </Dropdown>

              {/* <Select
                closeMenuOnSelect={true}
                options={selectedTipoReporte.value == 3 ? [...tiposVista.filter(entry => [0, 1, 2].includes(entry.value))] : [...tiposVista]}
                classNamePrefix={"react-select"}
                value={selectedTipoVista}
                onChange={(selected) => setSelectedTipoVista(selected)}
                styles={customStyles}

              /> */}
            </Form.Group>
          </Col>

          {/* Tiempo de estancia (minutos)  */}
          <Col md={2} xs={3}>
            <Form.Label className="me-2">Minutos de estancia</Form.Label>
            <Form.Group className="d-flex align-items-center">
              <Form.Control
                placeholder="0"
                value={tiempoEstancia}
                name="tiempo_estancia"
                onChange={handleFieldChange}
                type="number"
              // style={{ width: "80%" }}
              />

              {/* <Form.Label className="ms-2 mb-0"> <small>Minutos de estancia</small> </Form.Label> */}
            </Form.Group>
          </Col>


          {/* Boton Generar */}
          <Col md={2} xs={4} className="ms-auto">
            <div className="d-flex justify-content-center mt-4">
              <Button
                variant="primary"
                onClick={handleGenerate}
                className="w-100"
                disabled={!btnFiltroActivo || dateRangeInvalid || paginadorRecorridos.cargando}
              >
                Generar
              </Button>
              {/* {dateRangeWarning && (
          <Row className="mt-2">
            <Col>
              <div style={{ color: 'red', fontWeight: 'bold' }}>{dateRangeWarning}</div>
            </Col>
          </Row>
        )} */}
            </div>
          </Col>
          <Col md={2} xs={4}>
            <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
            </div>
          </Col>
        </Row>
      </div>
      {/* </Collapse> */}
    </div>
  );
}
